/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var moyaToggle = MoyaContainer.get('core.toggle');
    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('extras.bubble', function (el) {
        var bubble = new Bubble(el);
        bubble.run();
    });
    var Bubble = /** @class */ (function () {
        function Bubble(el) {
            this.el = el;
        }
        Bubble.prototype.run = function () {
            var _this = this;
            this.initLiveChat();
            var toggler = moyaToggle.create(this.el.querySelector('button'), this.el.querySelector('.bubble__content'), 'site_bubble', {
                onOpen: function () {
                    //this.el.querySelector('.bubble__content').classList.add('tilt-in-br');
                    _this.el.querySelector('.bubble__content').classList.add('open');
                    _this.el.querySelector('.bubble__content').classList.add('opening');
                    setTimeout(function () {
                        _this.el.querySelector('.bubble__content').classList.remove('opening');
                    }, 801);
                },
                onClose: function () {
                    _this.el.querySelector('.bubble__content').classList.add('closing');
                    setTimeout(function () {
                        _this.el.querySelector('.bubble__content').classList.remove('closing');
                        _this.el.querySelector('.bubble__content').classList.remove('open');
                        // @ts-ignore
                        //LiveChatWidget.call('hide');
                    }, 801);
                },
            });
            util.delegate(this.el.querySelector('.bubble__content'), 'click', '.bubble__close', function () {
                toggler.close();
            });
            util.delegate(this.el.querySelector('a[data-is-webchat="true"]'), 'click', 'a', function (e) {
                e.preventDefault();
                _this.webchatClick();
                toggler.close();
            });
        };
        Bubble.prototype.webchatClick = function () {
            // @ts-ignore
            LiveChatWidget.call('maximize');
            Bubble.chatElm.classList.remove('hidden');
        };
        Bubble.prototype.initLiveChat = function () {
            var observer = new MutationObserver(function (mutations, mutationInstance) {
                var chatDiv = document.getElementById('chat-widget-container');
                if (chatDiv) {
                    chatDiv.classList.add('hidden');
                    Bubble.chatElm = chatDiv;
                    mutationInstance.disconnect();
                }
            });
            // @ts-ignore
            LiveChatWidget.init();
            observer.observe(document, {
                childList: true,
                subtree: true,
            });
        };
        return Bubble;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
